import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTypo3Component } from './simple-icons-typo3.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTypo3Component ],
    exports:      [ SimpleIconsTypo3Component ],
    bootstrap:    []
})
export class SimpleIconsTypo3Module {}
